import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
/**
 * @ignore
 */
@Injectable({
  providedIn: 'root'
})
export class PopupService {

  private popupState$ = new BehaviorSubject<boolean>(null);
  public popupState = this.popupState$.asObservable();
  constructor() { }

  setState(state: boolean) {
    this.popupState$.next(state);
  }
  
}